export default __webpack_public_path__ + "static/bitdefender-7e19d2e603dd8d4f847077cbd0469dda.jpg";